export const setToken = (token) => {
    return {
        type: 'TOKEN',
        payload: token,
    };
};

export const setHistorialFiltro = (filtro) => {
    return {
        type: 'HISTORIAL_FILTRO',
        payload: filtro,
    };
};

export const resetHistorialFiltro = () => {
    return {
        type: 'HISTORIAL_FILTRO_RESET',
    };
};